import React, { Component } from 'react';
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Tab,
  Tabs
} from 'react-bootstrap';
import { Auth, API } from 'aws-amplify';
import './ProfileModal.css';

export default class ProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      editableName: '',
      email: '',
      editableEmail: '',
      jobtitle: '',
      editableJobTitle: '',
      company: '',
      editableCompany: '',
      country: '',
      editableCountry: '',
      telephone: '',
      editableTelephone: '',
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      currentSubscription: 'None',
      currentSubscriptionPlan: 'N/A',
      currentSubscriptionStartDate: 'N/A'
    };
  }

  async componentDidMount() {
    this.getProfileDetails();
    /* this.getSubscriptionDetails(); */
  }

  /* getSubscriptionDetails() {
    console.log('email request: ' + this.state.email);
    API.get('va-estimator', '/va-estimator/getsubscriptions', {
      body: this.state.email
    })
      .then(result => {
        console.log(result);
        if (result.data.length > 0) {
          let plan = 'N/A';
          const startDate = new Date(result.data[0].start * 1000);
          const startDateString =
            startDate.getDate() +
            '/' +
            (startDate.getMonth() + 1) +
            '/' +
            startDate.getFullYear();
          if (result.data[0].plan.interval === 'year') {
            plan = 'Yearly';
          } else if (result.data[0].plan.interval === 'month') {
            plan = 'Monthly';
          }

          this.setState({
            currentSubscription: 'Personal',
            currentSubscriptionPlan: plan,
            currentSubscriptionStartDate: startDateString
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  } */

  getProfileDetails = async event => {
    try {
      await Auth.currentAuthenticatedUser().then(user => {
        this.setState({
          name: user.attributes['custom:name'],
          email: user.attributes.email,
          jobtitle: user.attributes['custom:jobtitle'],
          company: user.attributes['custom:company'],
          country: user.attributes['custom:country'],
          telephone: user.attributes['custom:telephone'],
          editableName: user.attributes['custom:name'],
          editableEmail: user.attributes.email,
          editableJobTitle: user.attributes['custom:jobtitle'],
          editableCompany: user.attributes['custom:company'],
          editableCountry: user.attributes['custom:country'],
          editableTelephone: user.attributes['custom:telephone']
        });
        API.post('va-estimator', '/va-estimator/getsubscriptions', {
          body: {
            email: user.attributes.email
          }
        })
          .then(result => {
            console.log(result);
            if (result.data != null) {
              if (result.data.length > 0) {
                let plan = 'N/A';
                const startDate = new Date(result.data[0].start * 1000);
                const startDateString =
                  startDate.getDate() +
                  '/' +
                  (startDate.getMonth() + 1) +
                  '/' +
                  startDate.getFullYear();
                if (result.data[0].plan.interval === 'year') {
                  plan = 'Yearly';
                } else if (result.data[0].plan.interval === 'month') {
                  plan = 'Monthly';
                }

                this.setState({
                  currentSubscription: 'Personal',
                  currentSubscriptionPlan: plan,
                  currentSubscriptionStartDate: startDateString
                });
              }
            }
          })
          .catch(error => {
            console.error(error);
          });
      });
    } catch (e) {
      alert(e);
    }
  };

  validateForm() {
    return (
      this.state.email !== this.state.editableEmail &&
      this.state.editableEmail.length > 0
    );
  }

  validatePasswordForm() {
    return (
      this.state.currentPassword.length > 0 &&
      this.state.newPassword.length >= 8 &&
      this.state.newPassword === this.state.confirmNewPassword &&
      this.state.currentPassword !== this.state.newPassword
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSelect(key) {
    this.setState({ key });
  }

  handleSubmit = async event => {
    event.preventDefault();

    Auth.currentAuthenticatedUser()
      .then(user => {
        Auth.updateUserAttributes(user, {
          email: this.state.editableEmail
        })
          .then(result => {
            alert('Please check your new email address to confirm the change.');
            this.props.onHide();
          })
          .catch(error => console.error(error));
      })
      .catch(error => console.error(error));
  };

  handlePasswordChangeSubmit = async event => {
    event.preventDefault();
    Auth.currentAuthenticatedUser()
      .then(user => {
        Auth.changePassword(
          user,
          this.state.currentPassword,
          this.state.newPassword
        )
          .then(result => {
            alert('Password successfully changed.');
            this.props.onHide();
          })
          .catch(error => alert('Wrong password.'));
      })
      .catch(error => console.error(error));
  };

  handleDeleteAccount(e) {
    e.preventDefault();

    const confirmed = window.confirm(
      'Are you sure you want to delete your account? All of your estimates will also be deleted.'
    );

    if (!confirmed) {
      return;
    }

    this.onRemoveAccount();
  }

  onRemoveAccount() {
    //first try to cancel their stripe subscriptions, if any
    API.post('va-estimator', '/va-estimator/unsubscribe', {
      body: {
        email: this.state.email
      }
    })
      .then(result => {
        console.log('Successfully unsubscribed in Stripe.');
        //then delete their cognito account
        Auth.currentAuthenticatedUser()
          .then(
            (user: CognitoUser) =>
              new Promise((resolve, reject) => {
                this.state.estimates.forEach(e => {
                  this.deleteEstimate(e.estimateId);
                });

                user.deleteUser(error => {
                  if (error) {
                    return reject(error);
                  }
                  if (this.props.onSessionChange) {
                    this.props.onSessionChange();
                  }
                  document.location.href = '/login';

                  resolve();
                });
              })
          )
          .catch(this.onError);
      })
      .catch(error => {
        console.error('Error unsubscribing in Stripe.');
        console.error(error);
        return;
      });
  }

  render() {
    return (
      <Modal
        {...this.props}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg">
        <Modal.Header closeButton className="profile-modal-header">
          <Modal.Title id="contained-modal-title-lg">Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs defaultActiveKey={1} id="input-tabs">
            <Tab eventKey={1} title="Change Password">
              <form
                onSubmit={this.handlePasswordChangeSubmit}
                className="profile-form">
                <FormGroup controlId="currentPassword">
                  <ControlLabel>Current Password</ControlLabel>
                  <FormControl
                    type="password"
                    value={this.state.currentPassword}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup controlId="newPassword">
                  <ControlLabel>New Password</ControlLabel>
                  <FormControl
                    type="password"
                    value={this.state.newPassword}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <p>
                  Min. 8 characters with at least 1 number, 1 uppercase letter
                  and 1 lowercase letter
                </p>
                <FormGroup controlId="confirmNewPassword">
                  <ControlLabel>Confirm New Password</ControlLabel>
                  <FormControl
                    type="password"
                    value={this.state.confirmNewPassword}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <Button
                  bsStyle="success"
                  bsSize="large"
                  type="submit"
                  disabled={!this.validatePasswordForm()}>
                  Submit Changes
                </Button>
              </form>
            </Tab>
            <Tab eventKey={2} title="Edit Information">
              <p>Coming soon.</p>
              {/* <form onSubmit={this.handleSubmit} className="profile-form">
                <FormGroup controlId="editableEmail">
                  <ControlLabel>Email</ControlLabel>
                  <FormControl
                    type="email"
                    value={this.state.editableEmail}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <Button
                  bsStyle="success"
                  bsSize="large"
                  type="submit"
                  disabled={!this.validateForm()}>
                  Submit Changes
                </Button>
              </form> */}
            </Tab>
            <Tab eventKey={3} title="Subscriptions">
              <p>
                <span className="emphasis">Active Subscription:</span>{' '}
                {this.state.currentSubscription}
              </p>
              <p>
                <span className="emphasis">Payment Plan:</span>{' '}
                {this.state.currentSubscriptionPlan}
              </p>
              <p>
                <span className="emphasis">Subscription Start Date:</span>{' '}
                {this.state.currentSubscriptionStartDate}
              </p>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={e => this.handleDeleteAccount(e)} bsStyle="danger">
            Delete Account
          </Button> */}
          <Button onClick={this.props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProfileModal.js